import { Check, Share } from "lucide-react"
import { useEffect, useRef, useState } from "react"

const COPIED_MESSAGE_MS = 1500

export function DetailShareButton({ icon: IdleIcon = Share, iconOnly = false, label = "Share", shareUrl = null }) {
  const [copied, setCopied] = useState(false)
  const copiedTimerRef = useRef(null)

  useEffect(() => () => {
    if (copiedTimerRef.current) window.clearTimeout(copiedTimerRef.current)
  }, [])

  function copyLink() {
    const url = shareUrl || (typeof window !== "undefined" ? window.location.href : null)
    if (!url || typeof navigator === "undefined" || !navigator.clipboard?.writeText) return

    navigator.clipboard.writeText(url).then(() => {
      setCopied(true)
      if (copiedTimerRef.current) window.clearTimeout(copiedTimerRef.current)
      copiedTimerRef.current = window.setTimeout(() => {
        copiedTimerRef.current = null
        setCopied(false)
      }, COPIED_MESSAGE_MS)
    }, () => {})
  }

  const Icon = copied ? Check : IdleIcon

  return (
    <button
      type="button"
      className={`detail-share-button ${iconOnly ? "is-icon-only" : ""}`.trim()}
      aria-label={copied ? "Link copied" : label}
      title={copied ? "Copied" : label}
      onClick={copyLink}
    >
      <Icon aria-hidden="true" strokeWidth={1.8} />
      {iconOnly ? null : <span>{copied ? "Copied" : label}</span>}
    </button>
  )
}
